import { AttrField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { MarketingDataStatus } from '@/services/domain/marketingData/types'

@OrmModel(modelNames.MARKETING_DATA)
export default class MarketingData extends BaseModel {
  @StringField()
  public id: string

  @AttrField(null)
  public industry: string | null

  @AttrField(null)
  public useCase: string | null

  @AttrField(null)
  public source: string | null

  @AttrField(null)
  public description: string | null

  @AttrField()
  public status: MarketingDataStatus
}
